var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-meta-search" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header d-flex flex-row" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _c("em", [
                      _vm._v(_vm._s(_vm.$t("scrap-agent.meta-search.modal"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("modal:close")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: { customClass: "go-tooltip" },
                              expression: "{ customClass: 'go-tooltip' }",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "go-tooltip-area",
                          attrs: { title: _vm.$t("scrap-agent.modal_close") },
                        },
                        [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-area" }, [
                    _c("div", { staticClass: "form-group-add" }, [
                      _c("label", { staticClass: "go-form-label" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$t("scrap-agent.meta-search.title"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        _vm._l(_vm.formData.keyword, function (item, index) {
                          return _c("div", { key: index }, [
                            index > 0
                              ? _c(
                                  "div",
                                  { staticClass: "go-input-or-wrapper" },
                                  [
                                    _c("p", { staticClass: "go-input-or" }, [
                                      _vm._v("OR"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.keyword[index],
                                    expression: "formData.keyword[index]",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "scrap-agent.meta-search.placeholder"
                                  ),
                                },
                                domProps: {
                                  value: _vm.formData.keyword[index],
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formData.keyword,
                                      index,
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              index !== _vm.formData.keyword.length - 1
                                ? _c(
                                    "div",
                                    { staticClass: "go-input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn go-btn-icon",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handleRemoveKeyword(
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-close",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "go-input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn go-btn-icon",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handleAddMoreKeyword.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-plus",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: { type: "button", disabled: _vm.isDisable },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleAddMetasearchItem.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("scrap-agent.meta-search.btn-collection")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }